import styled from "styled-components";

import "../../../GlobalStyles/Font.css";
import { CustomButton } from "../../../Components/CustomButton/Button";

export const ButtonBackPage = styled(CustomButton)`
  width: 56px;
  height: 56px;
  background: #1ac63f;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    cursor: pointer;
  }
`;

export const IconButtonBack = styled.svg`
  fill: #fff;
  width: 24px;
  height: 24px;

  @media (min-width: 744px) {
    width: 13px;
    height: 13px;
  }

  @media (min-width: 1440px) {
    width: 24px;
    height: 24px;
  }
`;

export const NameUser = styled.h1`
  font-size: 20px;
  line-height: 1.2;
  font-family: "Exo2 Light";
  color: #000;

  @media (min-width: 744px) {
    display: flex;
    gap: 10px;
    font-size: 24px;
    line-height: 1.1;
  }

  @media (min-width: 1440px) {
    font-size: 36px;
    line-height: 1.19;
  }
`;

export const NicNameUserColor = styled.span`
  color: #1ac63f;
`;

export const ContainerSecurityPage = styled.div`
  margin: 0 auto;

  @media (min-width: 744px) {
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media (min-width: 1024px) {
    gap: 210px;
  }

  @media (min-width: 1440px) {
    gap: 310px;
    align-items: flex-start;
  }
`;

export const HeaderSecurityPage = styled.div`
  max-width: 100%;
  padding: 16px;
  display: flex;
  align-items: center;
  gap: 20px;

  @media (min-width: 744px) {
    width: 625px;
    display: flex;
    flex-direction: row;
    align-items: center;
  }

  @media (min-width: 1024px) {
    width: 788px;
    padding: 24px;
  }

  @media (min-width: 1440px) {
    width: 1118px;
  }
`;

export const TitlePage = styled.h1`
  margin-left: auto;
  display: none;

  color: #000;

  @media (min-width: 428px) {
    display: none;
  }

  @media (min-width: 744px) {
    display: block;
  }
`;

export const ContainerButton = styled.div`
  max-width: 100%;
  display: flex;
  flex-direction: column;
  gap: 30px;
  padding: 16px;

  @media (min-width: 428px) {
    max-width: 396px;
    margin: 0 auto;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    margin: 0;
  }

  @media (min-width: 1024px) {
    max-width: 309px;
    padding: 24px;
  }

  @media (min-width: 1440px) {
    max-width: 447px;
  }
`;

export const ButtonMainInfo = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonSecurity = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  background: #1ac63f;
  color: #fff;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const Languages = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonModes = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonLocalData = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonContantUs = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

export const ButtonCredits = styled(CustomButton)`
  width: 100%;
  padding: 18px;
  font-size: 16px;
  line-height: 1.18;
  transition: 450ms cubic-bezier(0.61, 0, 0.51, 1);
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  background: #fff;
  color: #000;
  font-family: "Exo2 Medium";
  border-radius: 20px;

  &:hover {
    cursor: pointer;
    transition:
      background 450ms cubic-bezier(0.61, 0, 0.51, 1),
      color 450ms cubic-bezier(0.61, 0, 0.51, 1),
      box-shadow 450ms cubic-bezier(0.61, 0, 0.51, 1);
    background: #1ac63f;
    color: #fff;
    box-shadow: 0px 0px 0px 0px #fff;
  }

  @media (min-width: 428px) {
    width: 396px;
  }

  @media (min-width: 744px) {
    width: 348px;
  }

  @media (min-width: 1024px) {
    width: 309px;
    font-size: 20px;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    width: 447px;
    font-size: 32px;
    line-height: 1.18;
  }
`;

// Security page features

export const SecurityPageContainer = styled.div`
  max-width: 358px;
  display: flex;
  flex-direction: column;
  padding: 16px;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
  }

  @media (min-width: 1024px) {
    max-width: 476px;
  }

  @media (min-width: 1440px) {
    max-width: 684px;
    padding: 24px;
  }
`;

export const TitleSecurePage = styled.h2`
  font-size: 20px;
  line-height: 1.2;
  font-weight: 500;
  font-family: "Exo2 Medium";
  text-align: center;
  color: #000;

  @media (min-width: 744px) {
    display: none;
  }
`;

// 2FA

export const TwoFAContainer = styled.div`
  max-width: 358px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-top: 20px;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    flex-direction: column;
    margin-top: 0px;
  }

  @media (min-width: 1024px) {
    max-width: 476px;
    flex-direction: row;
  }

  @media (min-width: 1440px) {
    max-width: 684px;
  }
`;

export const TwoFATitle = styled.h2`
  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;
  color: #000;

  @media (min-width: 744px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
    text-align: center;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

export const TwoFaButton = styled.button`
  background: #1ac63f;
  border-radius: 20px;
  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;
  color: #fff;
  max-width: 109px;
  padding: 15px 28px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    max-width: 190px;
    padding: 16px 69px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    padding: 16px 148px;
  }

  @media (min-width: 1024px) {
    max-width: 476px;
    padding: 13px 38px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
    margin-left: 30px;
  }

  @media (min-width: 1440px) {
    max-width: 684px;

    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
    margin-left: 80px;
  }
`;

// change password

export const ContainerIncludeValidationPassword = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 30px;
`;

interface IndicatorProps {
  width: number;
  color: string;
}

export const IndicatorPasswordValidation = styled.span<IndicatorProps>`
  height: 20px;

  /* показуємо повну білу смужку, якщо немає введення */
  width: ${(p) => (p.width === 0 ? "100%" : p.width + "%")};
  background: ${(p) => (p.width === 0 ? "#fff" : p.color)};

  box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  transition: 0.3s ease;
`;

export const FormChangePasswordContainer = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
`;

export const TitleChangePassword = styled.h2`
  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;
  margin-top: 40px;
  color: #000;

  @media (min-width: 1024px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

export const NewPasswordInput = styled.input`
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 18px 20px;
  color: #000;
  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;

  &::placeholder {
    color: #808080;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

export const NewRepeatPasswordInput = styled.input`
  background: #fff;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.25);
  border-radius: 20px;
  padding: 18px 20px;
  color: #000;
  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;

  &::placeholder {
    color: #808080;
  }

  @media (min-width: 1024px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

export const PolicyPrivacyButtonContainer = styled.div`
  margin-top: 30px;
`;

export const PolicyPrivacyButton = styled.button`
  background: #1ac63f;
  border-radius: 20px;
  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;
  color: #fff;
  max-width: 109px;
  padding: 15px 28px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    max-width: 190px;
    padding: 16px 69px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    padding: 16px 148px;
  }

  @media (min-width: 1024px) {
    max-width: 476px;
    padding: 13px 38px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    max-width: 684px;

    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

interface ButtonSignProps {
  $filled: boolean;
}

// {t("privateTraslate.Models.ConfirmEmailTextTimer")}
//  (t("privateTraslate.Models.ConfirmEmailConfirmedTextStatus"))
// ( t("privateTraslate.Models.ConfirmEmailTimeOut"))}

export const PasswordSaveButton = styled.input<ButtonSignProps>`
  background: ${(props) => (props.$filled ? "#1ac63f" : "#7fe495")};
  border-radius: 20px;
  padding: 18px 20px;
  color: #fff;

  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;

  cursor: ${(props) => (props.disabled ? "not-allowed" : "pointer")};
  opacity: ${(props) => (props.disabled ? 0.6 : 1)};
  transition: opacity 0.2s ease;

  @media (min-width: 1024px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

// delete account

export const DeleteAccountUserContainer = styled.div`
  max-width: 358px;
  display: flex;
  flex-direction: column;
  margin-top: 57px;

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 1024px) {
    max-width: 476px;
  }

  @media (min-width: 1440px) {
    max-width: 684px;
  }
`;

export const DangerZoneTitle = styled.h2`
  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;
  color: #000;

  @media (min-width: 744px) {
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;

export const DeleteAccount = styled.button`
  font-size: 16px;
  font-family: "Exo2 Medium";
  font-weight: 500;
  line-height: 1.18;
  color: #fff;

  max-width: 358px;
  background: #f64747;
  border-radius: 20px;
  padding: 18px 124px;
  margin-top: 40px;

  &:hover {
    cursor: pointer;
  }

  @media (min-width: 428px) {
    max-width: 396px;
  }

  @media (min-width: 744px) {
    max-width: 348px;
    padding: 15px 119px;
  }

  @media (min-width: 1024px) {
    max-width: 476px;
    font-size: 20px;
    font-weight: 500;
    line-height: 1.2;
  }

  @media (min-width: 1440px) {
    max-width: 684px;
    font-size: 32px;
    font-weight: 500;
    line-height: 1.18;
  }
`;
